import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const getDefaultState = () => {
  return {
    products: null,
    ranges: null,
    podium: null,
    onlineGreenProduct: null,
    onlineGrayProduct: null,
    forcedElecProduct: null,
    forcedGasProduct: null
  }
}

const state = getDefaultState();

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};


// WEBPACK FOOTER //
// ./src/store/modules/offer/index.js